import React from "react";
import T from '../../components/common/T';
import { useNavigate } from "react-router-dom";
// 🟢 FIXED: Import from WorkforceContext to match the ListView
import { useWorkforce } from "../../context/WorkforceContext"; 
import KanbanBoard from "../../components/common/KanbanBoard";

const EmployeeKanbanView = ({ filter = "All", search = "" }) => {
  const navigate = useNavigate();
  
  // 🟢 FIXED: Use workforce data instead of employees
  const { workforce = [], updateWorkforce } = useWorkforce();

  // 🟢 ADDED: Exact same filtering logic as the ListView
  const filteredWorkforce = workforce.filter((emp) => {
    const status = emp.status || "Active";
    const matchesFilter = filter === "All" || status === filter;
    const q = (search || "").toLowerCase();
    const matchesSearch =
      (emp.name || "").toLowerCase().includes(q) ||
      (emp.role || "").toLowerCase().includes(q) ||
      (emp.employee_id || "").toLowerCase().includes(q);
    return matchesFilter && matchesSearch;
  });

  const COLUMNS = [
    { id: "Active", title: "Active", dotColor: "bg-emerald-500" },
    { id: "On Leave", title: "On Leave", dotColor: "bg-amber-500" },
    { id: "Inactive", title: "Inactive", dotColor: "bg-gray-400" },
  ];

  const handleDragEnd = (result) => {
    const { destination, draggableId } = result;
    if (!destination) return;
    
    // Update the status in the backend
    if (updateWorkforce) {
      updateWorkforce(draggableId, { status: destination.droppableId });
    }
  };

  const renderCard = (emp) => (
    <div 
      onClick={() => navigate(`/admin/employee/view/${emp.id}`)}
      className="bg-white p-4 rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition cursor-grab active:cursor-grabbing flex flex-col min-h-[130px]"
    >
      <div className="flex justify-between items-start gap-2">
        <div className="overflow-hidden">
          <h4 className="font-bold text-gray-900 text-base leading-tight truncate">{emp.name}</h4>
          <p className="text-[11px] text-gray-500 font-mono mt-1">{emp.employee_id}</p>
        </div>
        <span className="text-[10px] bg-gray-100 text-gray-600 px-2 py-1 rounded font-bold uppercase tracking-wider border border-gray-200 shrink-0">
          {emp.role || 'Staff'}
        </span>
      </div>

      <div className="mt-auto pt-3 border-t border-gray-100 grid grid-cols-2 gap-3">
        <div className="overflow-hidden">
          <span className="block text-[10px] text-gray-400 font-bold uppercase tracking-wider mb-0.5"><T>Department</T></span>
          <span className="text-xs font-bold text-gray-700 truncate block">{emp.department || "General"}</span>
        </div>
        <div className="overflow-hidden">
          <span className="block text-[10px] text-gray-400 font-bold uppercase tracking-wider mb-0.5"><T>Contact</T></span>
          <span className="text-[11px] font-medium text-gray-600 truncate block">{emp.email || emp.phone || "—"}</span>
        </div>
      </div>
    </div>
  );

  return (
    <KanbanBoard 
      columns={COLUMNS}
      items={filteredWorkforce} // 🟢 Passes the filtered list to the board
      groupBy="status"
      onDragEnd={handleDragEnd}
      renderCard={renderCard}
    />
  );
};

export default EmployeeKanbanView;